// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>7</span>&nbsp;&nbsp;Our help is in the name of the Lord,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;who has made heaven and earth.<br> </p> </div></div>";
// Exports
module.exports = code;